// import { useState } from "react";
// import axios from "axios";

// export default function ContactSection() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await axios.post("http://localhost:8080/api/contact", formData);
//       alert("Message sent successfully!");
//       setFormData({ name: "", email: "", message: "" });
//     } catch (err) {
//       alert("Failed to send message");
//     }
//   };

//   return (
//     <div className="container mt-5 mb-5">
//       <h2 className="text-center fw-bold mb-4">📞 Contact Us</h2>

//       <div className="row g-4">
//         {/* FORM */}
//         <div className="col-md-6">
//           <div className="card shadow-sm p-4">
//             <form onSubmit={handleSubmit}>
//               <div className="mb-3">
//                 <label className="form-label">Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   className="form-control"
//                   required
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   className="form-control"
//                   required
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Message</label>
//                 <textarea
//                   name="message"
//                   className="form-control"
//                   rows="4"
//                   required
//                   onChange={handleChange}
//                 />
//               </div>

//               <button className="btn btn-primary w-100 fw-bold">
//                 Send Message
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* INFO + MAP */}
//         <div className="col-md-6">
//           <div className="card shadow-sm p-4 mb-3">
//             <p><strong>📍 Address:</strong> Tapola, Vanavli t. solasi, Maharashtra 412806</p>
//             <p><strong>📞 Phone:</strong> +91 82756 07686</p>
//             <p><strong>📧 Email:</strong> nivaraagrotourism@gmail.com</p>
//           </div>

//           <div className="card shadow-sm">
//             <iframe
//               title="map"
//              // src="https://www.google.com/maps?q=Sangli%20Maharashtra&output=embed"
//              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4086.474646496652!2d73.73564207548151!3d17.76672878318654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc26d00501ed705%3A0xff71928a4dd540c9!2sNivara%20Agro%20Tourism!5e1!3m2!1sen!2sin!4v1767525581930!5m2!1sen!2sin" 

//               width="100%"
//               height="250"
//               style={{ border: 0 }}
//               loading="lazy"
//             ></iframe>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


//******** Working with Java UI DESIGN ******//

// import React, { useState } from "react";
// import "./ContactUs.css";

// export default function ContactUs() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const [status, setStatus] = useState("");

//   // 🔹 Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // 🔹 Handle form submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.name || !formData.email || !formData.message) {
//       setStatus("Please fill all fields");
//       return;
//     }

//     setStatus("Sending...");

//     try {
//       const response = await fetch("http://localhost:8080/api/contact", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       if (!response.ok) throw new Error("Failed to send");

//       setFormData({ name: "", email: "", message: "" });
//       setStatus("Message sent successfully!");
//     } catch (error) {
//       console.error(error);
//       setStatus("Server error. Please try again.");
//     }
//   };

//   return (
//     <div className="contact-page-wrapper py-5">
//       <div className="container">
//         <div className="inner-contact-container shadow-lg">
//           <div className="row g-0">

//             {/* LEFT SIDE: FORM */}
//             <div className="col-lg-6 p-5 bg-white">
//               <div className="tile1-heading mb-3">Get in touch</div>
//               <p className="text-muted mb-4">
//                 We are here for you! How can we help?
//               </p>

//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3">
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="form-control form-field-custom"
//                     placeholder="Enter your name"
//                     required
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="form-control form-field-custom"
//                     placeholder="Enter your email address"
//                     required
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <textarea
//                     name="message"
//                     value={formData.message}
//                     onChange={handleChange}
//                     className="form-control form-field-custom"
//                     rows="4"
//                     placeholder="Go ahead we are listening..."
//                     required
//                   ></textarea>
//                 </div>

//                 <button
//                   type="submit"
//                   className="btn btn-roberto-contact w-100 py-3 fw-bold"
//                 >
//                   SUBMIT
//                 </button>

//                 {status && (
//                   <p className="mt-3 small text-center">{status}</p>
//                 )}
//               </form>
//             </div>

//             {/* RIGHT SIDE: IMAGE & INFO */}
//             <div
//               className="col-lg-6 p-5 text-dark"
//               style={{ backgroundColor: "#fff", borderLeft: "1px solid #eee" }}
//             >
//               <div className="tile2-image mb-4 text-center">
//                 <img
//                   src="/images/contact.png"
//                   alt="Contact Graphic"
//                   className="img-fluid"
//                   style={{ maxHeight: "250px", objectFit: "contain" }}
//                 />
//               </div>

//               <div className="ps-lg-4">
//                 <div className="d-flex align-items-center mb-4">
//                   <div className="contact-icon-circle me-3">
//                     <img src="/images/location.png" alt="Loc" width="16" />
//                   </div>
//                   <span className="fw-semibold">
//                     Tapola Vanavli, T. Solasi, Maharashtra 412806
//                   </span>
//                 </div>

//                 <div className="d-flex align-items-center mb-4">
//                   <div className="contact-icon-circle me-3">
//                     <img src="/images/phone.png" alt="Phone" width="16" />
//                   </div>
//                   <span className="fw-semibold">+91 82756 07686</span>
//                 </div>

//                 <div className="d-flex align-items-center mb-4">
//                   <div className="contact-icon-circle me-3">
//                     <img src="/images/mail.png" alt="Mail" width="16" />
//                   </div>
//                   <span className="fw-semibold">
//                     nivaraagrotourism@gmail.com
//                   </span>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


//7-8-26 Working with React JS

import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactUs.css";

// 🔹 Get these from your EmailJS dashboard (emailjs.com)
const EMAILJS_SERVICE_ID = "service_crf729o";
const EMAILJS_TEMPLATE_ID = "template_i41cx37";
const EMAILJS_PUBLIC_KEY = "fh4lmqLknOqzVSZlN";

const RECEIVER_EMAIL = "nivaragrotourism@gmail.com";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [sending, setSending] = useState(false);

  // 🔹 Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 🔹 Handle form submit — sends email directly from the browser, no backend
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill all fields");
      return;
    }

    setSending(true);
    setStatus("Sending...");

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
          title: `New message from ${formData.name}`,
        },
        EMAILJS_PUBLIC_KEY
      );

      setFormData({ name: "", email: "", message: "" });
      setStatus("Message sent successfully!");
    } catch (error) {
      console.error(error);
      setStatus("Failed to send. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-page-wrapper py-5">
      <div className="container">
        <div className="inner-contact-container shadow-lg">
          <div className="row g-0">

            {/* LEFT SIDE: FORM */}
            <div className="col-lg-6 p-5 bg-white">
              <div className="tile1-heading mb-3">Get in touch</div>
              <p className="text-muted mb-4">
                We are here for you! How can we help?
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control form-field-custom"
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control form-field-custom"
                    placeholder="Enter your email address"
                    required
                  />
                </div>

                <div className="mb-3">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control form-field-custom"
                    rows="4"
                    placeholder="Go ahead we are listening..."
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-roberto-contact w-100 py-3 fw-bold"
                  disabled={sending}
                >
                  {sending ? "SENDING..." : "SUBMIT"}
                </button>

                {status && (
                  <p className="mt-3 small text-center">{status}</p>
                )}
              </form>
            </div>

            {/* RIGHT SIDE: IMAGE & INFO */}
            <div
              className="col-lg-6 p-5 text-dark"
              style={{ backgroundColor: "#fff", borderLeft: "1px solid #eee" }}
            >
              <div className="tile2-image mb-4 text-center">
                <img
                  src="/images/contact.png"
                  alt="Contact Graphic"
                  className="img-fluid"
                  style={{ maxHeight: "250px", objectFit: "contain" }}
                />
              </div>

              <div className="ps-lg-4">
                <div className="d-flex align-items-center mb-4">
                  <div className="contact-icon-circle me-3">
                    <img src="/images/location.png" alt="Loc" width="16" />
                  </div>
                  <span className="fw-semibold">
                    Tapola Vanavli, T. Solasi, Maharashtra 412806
                  </span>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <div className="contact-icon-circle me-3">
                    <img src="/images/phone.png" alt="Phone" width="16" />
                  </div>
                  <span className="fw-semibold">+91 82756 07686</span>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <div className="contact-icon-circle me-3">
                    <img src="/images/mail.png" alt="Mail" width="16" />
                  </div>
                  <span className="fw-semibold">
                    nivaraagrotourism@gmail.com
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
